import * as Yup from "yup";

export const SignupValidationSchema = Yup.object({
  fullName: Yup.string().max(30, "Full name must be at most 30 characters").required("Full name is required"),
  email: Yup.string().email("Invalid email address").required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain at least one special character")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Confirm password is required"),
});

export const SigninValidationSchema = Yup.object({
  email: Yup.string().email("Invalid email address").required("Email is required"),
  password: Yup.string().required("Password is required"),
});

export const ForgotPasswordValidationSchema = Yup.object({
  email: Yup.string().email("Invalid email address").required("Email is required"),
});

export const RoleValidationSchema = (isEditMode, originalName) => {
  return Yup.object({
    roleName: Yup.string()
      .required("Role name is required")
      .test(
        "is-different",
        "New role name must be different from the current name",
        function (value) {
          return isEditMode ? value !== originalName : true;
        }
      ),
  });
}

const onlyLettersRegex = /^[A-Za-z\s]+$/;
const strictEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const educationRegex = /^[A-Za-z0-9\s().]+$/;
export const TutorValidationSchema = Yup.object({
  Name: Yup.string().trim().matches(onlyLettersRegex, 'Tutor Name must only contain letters').required('Tutor Name is required'),
  Gender: Yup.string().trim().required('Tutor Gender is required'),
  Email: Yup.string().trim().matches(strictEmailRegex, 'Invalid email format').required('Tutor Email is required'),
  Location: Yup.string().trim().required('Tutor location is required'),
  Dialect: Yup.string().trim().required('Tutor native language is required'),
  Age: Yup.number().typeError('Age must be a number').min(12).max(80).required('Tutor age is required'),
  Education: Yup.string().trim().matches(educationRegex, 'Invalid education format').required('Tutor education is required'),
  Language: Yup.string().trim().required('Tutor language is required'),
  Timezone: Yup.string().trim().required('Tutor timezone is required'),
  ExperienceLevel: Yup.number().typeError('Experience Level must be a number').min(0).max(50).required('Experience Level is required'),
  About: Yup.string().trim().max(500, 'About can be max 500 characters').required('About is required'),
  whatsappNumber: Yup.string()
    .test('phone-length', 'Phone number must be between 7 and 15 digits', (value) => {
      if (!value) return true; // Optional field
      const digitsOnly = value.replace(/\D/g, '');
      return digitsOnly.length >= 7 && digitsOnly.length <= 15;
    })
    .required('Phone number is required')
});